export const FIT_CALL_URL =
  "https://calendly.com/aa-ajility/discovery-call-1-clone";

export function fitCallUrl(placement: string): string {
  const url = new URL(FIT_CALL_URL);
  url.searchParams.set("utm_source", "ajility_site");
  url.searchParams.set("utm_medium", "referral");
  url.searchParams.set("utm_campaign", "fit_call");
  url.searchParams.set("utm_content", placement);
  return url.toString();
}

export const PHONE_CALL_URL =
  "https://calendly.com/aa-ajility/15-minute-phone-call";

export function phoneCallUrl(placement: string): string {
  const url = new URL(PHONE_CALL_URL);
  url.searchParams.set("utm_source", "ajility_site");
  url.searchParams.set("utm_medium", "referral");
  url.searchParams.set("utm_campaign", "phone_call");
  url.searchParams.set("utm_content", placement);
  return url.toString();
}
